<template>
  <div class="w-full flex shadow-md rounded-lg border-2">
    <div 
      class="h-24 w-24 lg:h-56 lg:w-56 flex-none bg-contain bg-center bg-no-repeat overflow-hidden border-r-10 lg:border-r-20 box-content " 
      :class="status"
      style="background-image: url('/img/biscoito.png')" 
    >
    </div>
    <div class="flex flex-col justify-between w-full p-2 px-4 lg:p-6 lg:px-10  leading-normal">
      <div>
        <h2 class="text-gray-700 text-left font-bold text-md lg:text-3xl mb-2">{{ name }}</h2>
      </div>
      <div class="flex flex-wrap items-center">
        <badge v-for="tag in tags" :key="tag" bgcolor="bg-blue-400 text-white active:bg-blue-600">
          {{ tag }}
        </badge>
      </div>
    </div>
  </div>
</template>

<script>
import Badge from './Badge.vue'

export default {
  props: {
    status: {
      type: String
    },
    name: {
      type: String
    },
    tags: {
      type: Array
    }
  },
  components: {
    'badge': Badge
  }
}
</script>

<style>

</style>